<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import api from './datas/api.js'
export default {
  name: 'app',
  mounted () {
    const getcode = localStorage.code || false
    const _this = this
    setInterval(() => {
      // heartbeat 心跳包
      if (getcode) {
        console.log('心跳包')
        try {
          _this.$get(api.heartbeat)
        } catch (e) {
          console.log(e)
        }
      }
    }, 60000) // 发送心跳包
  }
}
</script>

<style>
a,
a:focus,
a:hover {
  text-decoration: none;
}
html,
body {
  background: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue